import { Component, OnInit } from '@angular/core';
import {OverlayConfig, OverlayRef} from 'exc-controls';
import {ExcTranslation} from 'exc-core';

@Component({
  selector: 'app-modal-planning-hq-approval',
  templateUrl: './modal-planning-hq-approval.component.html',
  styles: []
})
export class ModalPlanningHqApprovalComponent extends ExcTranslation implements OnInit {

  constructor(private overlayConfig: OverlayConfig, private overlayRef: OverlayRef) {
    super();
  }

  proceed() {
    this.overlayRef.close({proceed: true});
  }
  ngOnInit() {
  }

}
